<template>
  <div>
    <div
      @click="openShowMicroDialog(true, {})"
      class="nipponia-customnav-none-app"
      v-if="devApps.length === 0"
    >
      当前尚无开发用的微应用，请点击加号后进行添加：
      <div class="el-icon-circle-plus"></div>
    </div>
    <el-row class="nipponia-customnav-app-wrapper" v-else>
      <el-col
        v-for="app in devApps"
        :key="app.id"
        class="nipponia-customnav-app"
      >
        <div class="nipponia-customnav-app--attr">
          <span>{{ app.showName }}</span>
          <span>（{{ app.appName }}）：</span>
          <span>{{ app.entryUrl }}</span>
          <span
            class="nipponia-customnav-btn"
            @click="openShowMicroDialog(true, app)"
            >修改</span
          >
          <span class="nipponia-customnav-btn" @click="delMicroApp(app)"
            >删除</span
          >
        </div>
        <template>
          <el-col
            v-for="tabPage in app.tabPages"
            :key="tabPage.id"
            class="nipponia-customnav-page"
          >
            <div
              class="nipponia-customnav-page--inner"
              @dblclick="gotoDevApp(app, tabPage)"
            >
              <span>{{ tabPage.showName }}：</span>
              <span>{{ tabPage.path }}</span>
              <span
                class="nipponia-customnav-btn"
                @click.stop="openShowPageDialog(true, app, tabPage)"
                >修改</span
              >
              <span
                class="nipponia-customnav-btn"
                @click.stop="delPage(app, tabPage)"
                >删除</span
              >
            </div>
          </el-col>
          <el-col class="nipponia-customnav-page">
            <span>添加页面：</span>
            <span
              class="el-icon-circle-plus"
              @click="openShowPageDialog(true, app, {})"
            ></span>
          </el-col>
        </template>
      </el-col>
      <el-col class="nipponia-customnav-app">
        <div>
          增加微应用：
          <div
            class="el-icon-circle-plus"
            @click="openShowMicroDialog(true, {})"
          ></div>
        </div>
      </el-col>
    </el-row>

    <el-dialog
      :title="!currentDevApp.appName ? '增加微应用' : '修改微应用'"
      :visible.sync="showMicroDialog"
      :close-on-click-modal="false"
    >
      <div class="nipponia-customnav--tips">
        <table>
          <tbody>
            <tr>
              <th>示例：</th>
            </tr>
            <tr>
              <td>项目某个页面的路由：</td>
              <td><b>https://localhost:8080/second-path/sample/xxxpage</b></td>
            </tr>
            <tr>
              <td>展示名称</td>
              <td>任意填写</td>
            </tr>
            <tr>
              <td>名称</td>
              <td>应用的唯一标识，路径中的<b>sample</b></td>
            </tr>
            <tr>
              <td>入口地址</td>
              <td><b>https://localhost:8080/second-path</b></td>
            </tr>
            <tr>
              <td>页面展示名称</td>
              <td>任意填写</td>
            </tr>
            <tr>
              <td>二级地址</td>
              <td>应用标识后的地址，即 <b>/xxxpage</b></td>
            </tr>
          </tbody>
        </table>
      </div>
      <el-form :model="currentDevApp">
        <el-form-item label="展示名称" :label-width="formLabelWidth">
          <el-input
            v-model="currentDevApp.showName"
            placeholder="请输入微应用展示名称（必填）"
          ></el-input>
        </el-form-item>
        <el-form-item label="名称" :label-width="formLabelWidth">
          <el-input
            v-model="currentDevApp.appName"
            placeholder="请输入微应用名称（必填）"
          ></el-input>
        </el-form-item>
        <el-form-item label="入口地址" :label-width="formLabelWidth">
          <el-input
            v-model="currentDevApp.entryUrl"
            placeholder="请输入微应用入口地址（必填）"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="openShowMicroDialog(false)">取 消</el-button>
        <el-button type="primary" @click="addMicroApp">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :title="!currentPage.path ? '增加页面' : '修改页面'"
      :visible.sync="showPageDialog"
      :close-on-click-modal="false"
    >
      <div class="nipponia-customnav--tips">
        <table>
          <tbody>
            <tr>
              <td>示例：</td>
            </tr>
            <tr>
              <td>项目某个页面的路由：</td>
              <td><b>https://localhost:8080/second-path/sample/xxxpage</b></td>
            </tr>
            <tr>
              <td>展示名称</td>
              <td>任意填写</td>
            </tr>
            <tr>
              <td>名称</td>
              <td>应用的唯一标识，路径中的<b>sample</b></td>
            </tr>
            <tr>
              <td>入口地址</td>
              <td><b>https://localhost:8080/second-path</b></td>
            </tr>
            <tr>
              <td>页面展示名称</td>
              <td>任意填写</td>
            </tr>
            <tr>
              <td>二级地址</td>
              <td>应用标识后的地址，即 <b>/xxxpage</b></td>
            </tr>
          </tbody>
        </table>
      </div>
      <el-form :model="currentPage">
        <el-form-item label="展示名称" :label-width="formLabelWidth">
          <el-input
            v-model="currentPage.showName"
            placeholder="请输入名称（必填）"
          ></el-input>
        </el-form-item>
        <el-form-item label="二级地址" :label-width="formLabelWidth">
          <el-input
            v-model="currentPage.path"
            placeholder="请输入二级地址（必填）"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="openShowPageDialog(false)">取 消</el-button>
        <el-button type="primary" @click="addPage">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { createMicroApp } from '@/config/microAppConfig.js'
import { mapActions, mapState } from 'vuex'
import showCurrentApp from '@/utils/showCurrentApp.js'

export default {
  name: 'ResourceMenu',
  data: function () {
    return {
      showMicroDialog: false,
      showPageDialog: false,
      currentDevApp: {},
      currentPage: {},
      app: {},
      devApps: [
        {
          id: Math.random(),
          appName: 'cherrug-app',
          showName: '角色',
          entryUrl: 'http://localhost:8131',
          status: '',
          tabPages: [
            {
              id: Math.random(),
              showName: '角色定义',
              path: 'cherrug_calculate_progress_board',
              status: '',
            },
          ],
        },
      ],
      formLabelWidth: '120',
    }
  },
  created() {
    this.devApps =
      JSON.parse(localStorage.getItem('nipponia-web:devApps')) || []
  },
  computed: {
    ...mapState(['currentMicroApps', 'keycloakToken', 'appsInOrg']),
  },
  watch: {
    devApps: {
      handler(newV) {
        localStorage.setItem('nipponia-web:devApps', JSON.stringify(newV || []))
        const devApp = (newV || []).map((app) => {
          const newDevApp = {
            ...app,
            microFrontFlag: '1',
            id: app.appName,
            name: app.appName,
            entry: app.entryUrl,
            container: '#' + app.appName,
            activeRule: '/' + app.appName,
          }
          return newDevApp
        })
        const stringApp = JSON.parse(
          JSON.stringify(this.currentMicroApps || [])
        )
        const stringApp2 = JSON.parse(JSON.stringify(this.appsInOrg || []))
        devApp.forEach((app) => {
          const index = stringApp.findIndex((a) => a.id === app.id)
          const index2 = stringApp2.findIndex((a) => a.id === app.id)
          if (index === -1) {
            stringApp.push(app)
          } else {
            stringApp.splice(index, 1, app)
          }
          if (index2 === -1) {
            stringApp2.push(app)
          } else {
            stringApp2.splice(index, 1, app)
          }
        })
        this.setCurrentMicroApps(stringApp)
        this.setAppsInOrg(stringApp2)
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions(['setCurrentMicroApps', 'setAppsInOrg']),
    // ---------------------------------------------
    gotoDevApp(appq, pageq) {
      let page = JSON.parse(JSON.stringify(pageq))
      page.path = '/' + appq.appName + page.path
      page.showName = 'dev-' + page.showName
      console.log(page.path, '测试用path')
      createMicroApp({
        ...page,
        microFrontFlag: '1',
        pageUrl: page.path,
        title: page.showName,
        applicationName: appq.appName,
      }).then(async (res) => {
        await this.$tabs.openTab({
          title: page.showName,
          titleParent: ['开发', '测试', page.appName],
          path: page.path,
          query: {},
        })
        this.$nextTick(() => {
          showCurrentApp()
        })
      })
    },
    openShowMicroDialog(disabled, app) {
      this.showMicroDialog = disabled
      this.currentDevApp = disabled ? app : {}
      this.currentDevApp = JSON.parse(JSON.stringify(this.currentDevApp))
    },
    openShowPageDialog(disabled, app, tabPage) {
      this.showPageDialog = disabled
      this.currentDevApp = disabled ? app : {}
      this.currentPage = disabled ? tabPage : {}
      this.currentDevApp = JSON.parse(JSON.stringify(this.currentDevApp))
      this.currentPage = JSON.parse(JSON.stringify(this.currentPage))
    },
    addMicroApp() {
      const pushDevApp = {
        ...this.currentDevApp,
        id: this.currentDevApp.id || Math.random(),
        tabPages: this.currentDevApp.tabPages || [],
      }
      const index = this.devApps.findIndex(
        (devapp) => devapp.id === pushDevApp.id
      )
      if (index === -1) {
        this.devApps.push(pushDevApp)
      } else {
        this.devApps.splice(index, 1, pushDevApp)
      }
      this.openShowMicroDialog(false)
    },
    delMicroApp(app) {
      const index = this.devApps.findIndex((devapp) => devapp.id === app.id)
      if (index === -1) {
        return false
      }
      this.devApps.splice(index, 1)
    },
    addPage() {
      const pushPage = {
        ...this.currentPage,
        id: this.currentPage.id || Math.random(),
      }
      const index = this.currentDevApp.tabPages.findIndex(
        (page) => page.id === pushPage.id
      )
      if (index === -1) {
        this.currentDevApp.tabPages.push(pushPage)
      } else {
        this.currentDevApp.tabPages.splice(index, 1, pushPage)
      }
      const appIndex = this.devApps.findIndex(
        (devapp) => devapp.id === this.currentDevApp.id
      )
      this.devApps.splice(appIndex, 1, this.currentDevApp)
      this.openShowPageDialog(false)
    },
    delPage(app, page) {
      const index = app.tabPages.findIndex((tab) => tab.id === page.id)
      if (index !== -1) {
        app.tabPages.splice(index, 1)
      }
      const appIndex = this.devApps.findIndex((devapp) => devapp.id === app.id)
      this.devApps.splice(appIndex, 1, app)
    },
    // ---------------------------------------------
    // 网址校验
    isURL(strUrl) {
      const strRegex =
        /^(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-/]))?/
      return strRegex.test(strUrl)
    },
  },
}
</script>

<style lang="scss" scoped>
.nipponia-customnav {
  &-none-app {
    margin: 10px 20px 0;
    font-size: 1.2em;
    .el-icon-circle-plus {
      font-size: 2em;
    }
  }
  &-app {
    cursor: pointer;
    margin: 10px 20px 0;
    font-weight: 600;
    font-size: 1.2em;
    &--attr {
      padding: 12px 0;
      color: #4e4e4e;
      &:hover {
        color: #000000;
        background-color: #e4e4e4;
      }
    }
  }
  &-page {
    padding: 3px 0;
    font-weight: 300;
    font-size: 1em;
    text-indent: 2em;
    &--inner {
      padding: 6px 0;
    }
    &:hover {
      color: #000000;
      background-color: #e4e4e4;
    }
  }
  &-btn {
    padding: 6px;
    font-weight: initial;
    color: rgb(197, 197, 197);
    &:hover {
      cursor: pointer;
      color: rgb(0, 0, 0);
    }
  }
  &--tips {
    border: 1px solid #eee;
    table,
    tbody {
      width: 100%;
      th {
        text-align: left;
      }
      td,
      th {
        padding: 6px 0;
      }
      td {
        border-bottom: 1px solid #eee;
      }
    }
    div {
      padding: 3px 0;
    }
  }
}
</style>
